import { defineStore } from "pinia";

export const useCartStore = defineStore("cart", {
  state: () => ({
    citations: [] as Server.ICitationSearchResult[],
    checkoutTimer: null as Date | null,
  }),

  getters: {
    totalItemsInCart: (state) => {
      return state.citations.length;
    },

    getAsPurchases: (state) => {
      const citations: Server.ICitationPurchase[] = state.citations.map(
        (item) => ({
          InquiryID: item.Overview.InquiryID,
          PaymentMethodID: 1, // Default payment method ID, adjust as needed;
          AmountToPay: item.Overview.AmountToPay,
        }),
      );

      return [...citations] as Server.ICitationPurchase[];
    },
  },

  actions: {
    addCitation(citation: Server.ICitationSearchResult) {
      const alreadyInCart = this.citations.some(
        (item) =>
          item.Overview.Court === citation.Overview.Court &&
          item.Overview.CaseNo === citation.Overview.CaseNo,
      );
      if (alreadyInCart) {
        //remove item and readd it.
        this.citations = this.citations.filter((item) => {
          return (
            item.Overview.Court !== citation.Overview.Court ||
            item.Overview.CaseNo !== citation.Overview.CaseNo
          );
        });
         this.citations.push(structuredClone({ Overview: citation.Overview, Assessments: citation.Assessments, Attachments: citation.Attachments } as Server.ICitationSearchResult ));

      } else {
        this.citations.push(structuredClone({ Overview: citation.Overview, Assessments: citation.Assessments, Attachments: citation.Attachments } as Server.ICitationSearchResult ));
      }
    },

    removeCitation(citation: Server.ICitationSearchResult) {
      this.citations = this.citations.filter(
        (cartItem) => cartItem !== citation,
      );
    },

    clearCart() {
      this.citations = [];
    },
    setCheckoutTimer(searchDate: Date) {
      this.checkoutTimer = searchDate;
    },
    clearCheckoutTimer() {
      this.checkoutTimer = null;
    },
  },
  persist: {
        key: 'citation-cart',
    }
});
